import { Game } from './core/Game.js';
import { showStart, bootError } from './core/Boot.js';
import S from './core/Registry.js';
import { bus } from './core/EventBus.js';
import { initSocialGrowth } from './core/SocialGrowth.js';

const canvas = document.getElementById('gl');

window.addEventListener('error', (e) => bootError('runtime', e.error || e.message));
window.addEventListener('unhandledrejection', (e) => bootError('promise', e.reason));

const game = new Game(canvas);
initSocialGrowth();

game.boot()
  .then(() => {
    // Audio and pointer lock both require a user gesture, so gate on a click.
    showStart((source) => {
      if (source === 'gamepad') S.input?.suppressGamepadUntilRelease?.('confirm');
      // One start intent is the shared boundary for Game and Portal. Game owns
      // the actual loop; Portal observes the same event to mark a trusted run.
      bus.emit('ui:start', { source });
    });
  })
  .catch((err) => {
    bootError('boot', err);
    console.error(err);
  });
